<div class="info">
  <div class="info__item">
    <mat-label>{{ 'customers.viewCustomer.customerName' | translate }}</mat-label>
    <span>{{ customerInfo()?.firstName }} {{ customerInfo()?.lastName }}</span>
  </div>

  <div class="info__item">
    <mat-label>{{ 'customers.viewCustomer.email' | translate }}*</mat-label>
    <span>{{ customerInfo()?.email }}</span>
  </div>

  <div class="info__item">
    <mat-label>{{ 'customers.viewCustomer.phoneNumber' | translate }}</mat-label>
    <span>{{ customerInfo()?.phoneNumber }}</span>
  </div>

  <div class="info__item">
    <mat-label>{{ 'customers.viewCustomer.loyaltyId' | translate }}</mat-label>
    <span>{{ customerInfo()?.loyaltyId }}</span>
  </div>

  <div class="info__item">
    <mat-label>{{ 'customers.viewCustomer.status.label' | translate }}</mat-label>
    <span class="status" [ngClass]="{ active: isActive(), inactive: !isActive() }">
      {{
        isActive()
          ? ('customers.viewCustomer.status.active' | translate)
          : ('customers.viewCustomer.status.deactivated' | translate)
      }}
    </span>
  </div>

  <div class="info__item full-width">
    <mat-label>{{ 'customers.viewCustomer.remarks.label' | translate }}</mat-label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <input
        matInput
        [placeholder]="'customers.viewCustomer.remarks.placeholder' | translate"
        [value]="customerInfo()?.remarks || ''"
        disabled
      />
    </mat-form-field>
  </div>
</div>

<div class="actions">
  <button mat-button type="button" class="btn--close" (click)="onClose()">
    {{ 'customers.viewCustomer.buttons.close' | translate }}
  </button>
</div>
